import { ConfirmModal, Title } from '@/ui'
import styles from './SocialLeaveStyles.module.scss'
import { contractsActions, contractsSelectors, contractsThunks } from '@/entity'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { earlyExitLeaveDelete, sendSignedEarlyExitSocialLeave } from '@/entity/contracts/model/thunks'
import { message } from 'antd'
import { DigitalSign } from '@/utils/digitalSign'

export const RemoveEarlySocialLeaveModal = ({ onClose, socialLeave, isLoading }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {contract} = useSelector((state) => ({
		contract: state.contracts.contract?.data,
	}))
	const digitalSign = new DigitalSign()

	const onSuccess = () => {
		dispatch(contractsThunks.getContract(contract?.externalId, contract?.isLocalContract))
		message.success('Операция выполнена успешно', 10)
		dispatch(contractsActions.setSocialLeaveIsSuccess(false))
	}

	const onDelete = () => {
		let body = {
			payload: {
				status: socialLeave?.earlyExitSocialLeave?.status
			},
			data: {
				socialLeaveExternalId: socialLeave?.externalId,
				bin: contract?.bin,
				iin: contract?.iin,
			},
			onSuccess: async (res, isXml) => {
				if(isXml){
					const xml = await digitalSign.handleSend(res)

					let innerBody = {
						data: {
							signedXml: xml,
							externalId: null,
							entityId: null,
							paramMap: null,
						},
						onSuccess: onSuccess
					}

					dispatch(contractsThunks.sendSignedEarlyExitSocialLeave(innerBody))
					dispatch(contractsActions.setSocialLeaveIsLoading(false))
				} else {
					onSuccess()
				}
			}
		}

		dispatch(earlyExitLeaveDelete(body))
	}

	return (
		<ConfirmModal
			onProcess={onDelete}
			onCancel={onClose}
			cancelButtonTitle={'cancel'}
			processButtonTitle={'delete_action'}
			hideBackButton
			priority={2}
			isLoading={isLoading}
		>
			<div className={styles.content}>
				<Title className={styles.content__title}>{t('social_leave.early.deleteTitle')}</Title>
				<p className={styles.content__body}>
					{t('social_leave.early.deleteSubtitle', {
						socialLeaveNumber: socialLeave?.id ? `№ ${socialLeave?.id}` : '',
						contractNumber: contract?.contractNumber || '',
						contractDate: socialLeave?.entryDate || '',
					})}
				</p>
			</div>
		</ConfirmModal>
	)
}
